import BaseElevationLayer from '@arcgis/core/layers/BaseElevationLayer';
import ElevationLayer from '@arcgis/core/layers/ElevationLayer';

// Esri's default `world-elevation` ground (Terrain3D).
const WORLD_ELEVATION_URL = 'https://elevation3d.arcgis.com/arcgis/rest/services/WorldElevation3D/Terrain3D/ImageServer';

// Custom ground elevation layer that lowers (or raises) world-elevation by a uniform
// `offset` (metres). Published data is NAVD88 orthometric, which sits ~one geoid
// separation off the WGS84 terrain; instead of lifting every data layer by that amount,
// we shift the terrain once to meet the native-Z data. Mirrors Esri's official
// ExaggeratedElevationLayer sample (a BaseElevationLayer subclass that rewrites tile
// values in fetchTile) — we add a constant rather than multiply.
//
// `offset` is the geoid shift to apply to the terrain: pass `-geoidOffsetZ` so the
// ground drops to where the data renders. Changing `offset` only affects tiles fetched
// afterwards, so callers recreate the layer (and reassign `map.ground`) to re-apply it.
// eslint-disable-next-line import/prefer-default-export
export const OffsetElevationLayer = (BaseElevationLayer as any).createSubclass({
  properties: {
    offset: 0,
  },

  load() {
    (this as any)._elevation = new ElevationLayer({ url: WORLD_ELEVATION_URL });
    (this as any).addResolvingPromise((this as any)._elevation.load());
  },

  fetchTile(level: number, row: number, col: number, options: any) {
    return (this as any)._elevation
      .fetchTile(level, row, col, options)
      .then((data: any) => {
        const { offset } = this as any;
        if (offset) {
          const { values, noDataValue } = data;
          for (let i = 0; i < values.length; i += 1) {
            if (values[i] !== noDataValue) {
              values[i] += offset;
            }
          }
        }
        return data;
      });
  },
});
